<template>
  <div class="page">
    <h2 style="margin: 0 0 16px; font-size: 20px; font-weight: 600;">Select Company</h2>
    <ul class="list">
      <li
          v-for="c in companies"
          :key="c.id"
          class="card"
          style="cursor: pointer;"
          @click="selectCompany(c.id)"
      >
        <div class="row">
          <div style="display: flex; gap: 12px; align-items: center;">
            <i class="fa-solid fa-building" style="color: #42b983; font-size: 18px;"></i>
            <span class="num">{{ c.name }}</span>
          </div>
          <i class="fa-solid fa-chevron-right" style="color: #9fb0c7;"></i>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CompanySelect',
  data() {
    return {
      companies: [
        { id: '92d854d6-9dff-458e-a4aa-76aa302ee150', name: 'YSA TRANSPORT LLC' },
        { id: '616b9deb-04ec-486c-ac55-191d6f9ffe85', name: 'NATURE DISPATCH LLC' },
      ],
    }
  },
  methods: {
    selectCompany(companyId) {
      this.$router.push({ name: 'TruckList', params: { companyId } })
    },
  },
}
</script>

<style scoped>
@import './TruckList.css';
</style>
